import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'walletFilter', standalone: true })
export class WalletFilterPipe implements PipeTransform {
  transform(wallets: any[], currency: string): any {
    if (!wallets || !currency) {
      return wallets;
    }

    const copyWallets = [...wallets];

    return copyWallets.filter((wallet) => {
      if (
        wallet.currency.toUpperCase().indexOf(currency.toUpperCase()) !== -1 ||
        wallet.name.toUpperCase().indexOf(currency.toUpperCase()) !== -1
      ) {
        return wallet;
      }
    });
  }
}
